module.exports = __webpack_public_path__ + "img/partnerRed.d0aa6525.jpg";